import { css } from '@emotion/react';

export const DebugWrapperCss = css(
    `border: 2px dashed rgba(110, 96, 98, 0.5); &:hover {background: rgba(89, 77, 79, 0.2); border-color: rgba(110, 96, 98, 1)}`,
);
